<div class="container aztec-scanner-info"
    [ngClass]="{
        'aztec-scanner-info--sections-below': sectionsBellow,
        'aztec-scanner-info--data-clear': dataClear,
        'aztec-scanner-info--data-entered-manually': dataEnteredManually,
        'aztec-scanner-info--diagnostic-station': diagnosticStationScanView
    }">

    <div class="aztec-scanner-info__container">
        <div *ngIf="!diagnosticStationScanView"
             class="aztec-scanner-info__subtitle"
            [innerHTML]="subtitle | translate | safeHtml">
        </div>

        <div class="aztec-scanner-info__image">
            <img [src]="imageSrc"
                 (click)="scanCode()"
                 alt="">
        </div>

        <div *ngIf="!aztecScannedFromQrCode"
             class="aztec-scanner-info__button">

            <div *ngIf="diagnosticStationScanView"
                 [innerHTML]="'AZTEC_SCANNER_INFO.subtitleDiagnosticStation' | translate | safeHtml"
                 class="aztec-scanner-info__button__diagnostic-station-info">
            </div>

            <button (click)="scanCode()"
                    class="btn btn--secondary btn--big btn--no-outline">
                {{ 'AZTEC_SCANNER_INFO.scanCode' | translate }}
            </button>
        </div>

        <div *ngIf="footerVisible"
             class="aztec-scanner-info__footer"
             [innerHTML]="'AZTEC_SCANNER_INFO.footer' | translate | safeHtml">
        </div>

        <div *ngIf="diagnosticStationScanView && !aztecScannedFromQrCode"
             class="aztec-scanner-info__diagnostic-station-button">
            <button (click)="scanCode()"
                    class="btn btn--secondary btn--big btn--no-outline">
                {{ 'AZTEC_SCANNER_INFO.scanCode' | translate }}
            </button>
        </div>

        <div *ngIf="aztecScannedFromQrCode"
             class="aztec-scanner-info__scan-again-btn">
            <button (click)="scanCode()"
                    class="btn btn--clear-arrow">
                {{ 'AZTEC_SCANNER_INFO.scanAgain' | translate }}
                <span class="material-icons">arrow_right</span>
            </button>
        </div>
    </div>
</div>
